import React from 'react';
import { useSelector } from 'react-redux';
import { FiCalendar, FiUser, FiBriefcase } from 'react-icons/fi';
import "./TaskCard.scss";

type Task = {
  _id: string;
  taskName: string;
  employeeName?: string;
  clientName?: string;
  startDate: string; 
  dueDate: string;
  activityType: string;
};

const TaskCard = () => {
  const { getHrbpDashboardData } = useSelector((state: any) => state.employeeReducer);
  
  const upcomingTasks: Task[] = getHrbpDashboardData?.data?.upcomingTasks || [];

  const formatStartDate = (startDate: string) => {
    const daysUntilStart = Math.ceil((new Date(startDate).getTime() - new Date().getTime()) / (1000 * 3600 * 24));
    
    if (daysUntilStart < 0) {
      return <span className="sla-text-overdue">Started</span>; 
    }
    if (daysUntilStart === 0) {
      return <span className="sla-text-today">Starts Today</span>;
    }
    if (daysUntilStart === 1) {
      return <span className="sla-text">Starts in 1 day</span>;
    }
    return <span className="sla-text">Starts in {daysUntilStart} days</span>;
  };

  return (
    <div className="upcoming-tasks-sidebar"> 
      <div className="sidebar-header">
        <FiCalendar color="#17a2b8" size={18} />
         <h5 className="sidebar-title">On Deck</h5> 
         {/* up next, starting soon, next action */} 
        {upcomingTasks.length > 0 && (
          <span className="upcoming-count-badge">{upcomingTasks.length}</span>
        )}
      </div>

      <div className="tasks-list">
        {upcomingTasks.length > 0 ? (
          upcomingTasks.map((task) => (
            <div key={task._id} className="upcoming-task-card">
              <div className="task-card-header">
                <p className="task-name">{task.taskName}</p>
              </div>
              <div className="task-card-body">
                <div className="info-line">
                  <FiUser size={12} className="info-icon" />
                  <span className="info-text">{task.employeeName || 'N/A'}</span>
                </div>
                 <div className="info-line">
                  <FiBriefcase size={12} className="info-icon" />
                  <span className="info-text">{task.clientName || 'N/A'}</span>
                </div>
                <div className="info-line">
                  <FiCalendar size={12} className="info-icon" />
                  <span className="info-text">{new Date(task.startDate).toLocaleDateString()}</span>
                </div>
              </div>
              <div className="task-card-footer">
                 <span className="activity-type-pill">{task.activityType}</span>
                 {formatStartDate(task.startDate)}
              </div>
            </div>
          ))
        ) : (
          <div className="no-tasks-placeholder">
            <p>No upcoming tasks.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskCard;